import { Port } from '../../types/models'
import { PortConfig } from '../../types/ports'
import { PortControl } from './PortControl'

/**
 * Controller for ports not yet visible.
 */
export class FuturePortControl extends PortControl<Port, PortConfig> {

  getDescription(): string { return this.app.t('Future use only') }

  getName(): string { return this.app.t('Future use only') }

  get isVisible() { return false }
}
